<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <app-bar :title="`Thu hồi thiết bị`"/>
        <v-flex xs12 sm12 md8 lg6 xl6 offset-md2 offset-lg3 offset-xl3>
          <v-card>
            <v-container>
              <v-card-text class="pa-10">
                <v-form v-model="form.isValid" ref="form">
                  <v-autocomplete
                    v-model="form.sourceId"
                    label="Thu về"
                    :items="dealers"
                    item-text="name"
                    item-value="id"
                    :rules="[validate.required]"
                  ></v-autocomplete>
                  <v-text-field v-model="form.refCode" label="Mã phiếu xuất hàng"></v-text-field>
                  <v-text-field v-model="form.remark" label="Ghi chú"></v-text-field>
                  <v-textarea
                    auto-grow
                    label="Danh sách IMEI"
                    v-model="form.imeiStr"
                    hint="Mỗi số IMEI cần xuống dòng để phân biệt"
                    :rules="[validate.required]"
                  ></v-textarea>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="clear()">Nhập lại</v-btn>
                <v-btn color="primary" dark @click="submit()" :loading="isLoading">Thu hồi thiết bị</v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import validate from '@/utils/validate';
import AppBar from '@/components/appbar';

export default {
  components: {
    AppBar
  },

  data () {
    return {
      validate: validate,
      isLoading: false,
      dealers: [],
      form: {
        isValid: false,
        imeiStr: '',
        imeis: [],
        sourceId: '',
        refCode: '',
        remark: ''
      }
    };
  },

  watch: {
    'form.imeiStr' () {
      if (this.form.imeiStr) {
        let arr = this.form.imeiStr.split('\n');
        this.form.imeis = [];
        arr.map(a => {
          if (a) this.form.imeis.push(a.trim());
          return 0;
        });
      }
    }
  },

  mounted () {
    Promise.all([this.getDealers(), this.getDistributors()])
      .then(([dealers, distributors]) => {
        const map = new Map();
        [...distributors, ...dealers].forEach(a => map.set(a.id, a));
        this.dealers = [...map.values()];
      })
      .catch(err => console.log(err));
  },

  methods: {
    ...mapActions(['getDealers', 'getDistributors', 'returnDevices']),
    clear () {
      this.form = {
        imeiStr: '',
        imeis: [],
        sourceId: '',
        refCode: '',
        remark: ''
      };
      this.$refs.form.reset();
    },
    submit () {
      if (this.form.isValid) {
        this.isLoading = true;
        this.returnDevices(this.form)
          .then(_ => {
            this.isLoading = false;
            window.getApp.showMessage('Thu hồi thiết bị thành công');
            // this.clear();
            window.history.back();
          })
          .catch(err => {
            this.isLoading = false;
            let msg = '';
            if (err === 'ERR_INVALID_PERMISSION') {
              msg =
                'Không thể thu hồi thiết bị thuộc quyền sở hữu của tài khoản khác';
            } else {
              msg = 'Thu hồi thiết bị thất bại, vui lòng thử lại';
            }
            window.getApp.showMessage(msg, 'error');
          });
      } else {
        this.$refs.form.validate();
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/device/return.vue